export const PLUGIN_NAME = 'auth-fe';
export const COOKIE_KEY = 'blaze_auth';
export const GRAPH_QL_ERROR = 'GraphQL error: ';
export const PRIORITY_HIGH = 'high';
//# sourceMappingURL=constants.js.map